import { formatPrice } from '@payaca/helpers/financeHelper';
import { FC } from 'react';

type Props = {
  value: {
    valueInMinor: string;
    currency: { code: string; exponent: number };
  };
};

/**
 * Renders a fractional minor-unit money value (a GraphQL FractionalCurrencyValue)
 * to up to four decimal places — never fewer than the conventional two — to
 * surface the sub-penny precision that stock cost and value are held to.
 */
const FractionalCurrencyValue: FC<Props> = (props) => {
  const { valueInMinor, currency } = props.value;

  return (
    <>
      {formatPrice(navigator.language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      })({
        priceInMinorCurrencyUnits: Number(valueInMinor),
        exponent: currency.exponent,
        currencyCode: currency.code,
      })}
    </>
  );
};

export default FractionalCurrencyValue;
